/** The QA package reuses authentication and pages with a focused navigation profile. */
export const qaPanel = import.meta.env.VITE_BUILDING_REVIEW_PANEL === 'true'

/**
 * Plotea web build (`VITE_APP_BRAND=plotea`, plotea-web): the Site product under
 * the Plotea brand, without Archigma navigation. Contract: docs/architecture/plotea.md.
 */
export const ploteaApp = import.meta.env.VITE_APP_BRAND === 'plotea'

/** Brand name shown in the app shell and on Site output. */
export const productName = ploteaApp ? 'Plotea' : 'Archigma'

export const appHome = ploteaApp
  ? '/site'
  : qaPanel
    ? '/building-review'
    : '/jobs'

export function qaPanelPath(path: string): boolean {
  return (
    [
      '/',
      '/login',
      '/building-review',
      '/organizations',
      '/desktop/authorize',
    ].includes(path) ||
    path.startsWith('/verify-email/') ||
    path.startsWith('/organizations/') ||
    path === '/legal/host-analytics/host-analytics-v1'
  )
}

/** Routes of the Plotea web app; every other path redirects to `/site`. */
export function ploteaPath(path: string): boolean {
  return (
    path === '/login' ||
    path === '/magic-link' ||
    path === '/verify-email' ||
    path === '/invite' ||
    path === '/reset-password' ||
    path === '/organization' ||
    path === '/privacy' ||
    path === '/terms' ||
    path === '/site' ||
    path.startsWith('/site/') ||
    path.startsWith('/verify-email/')
  )
}
